import * as types from './mutation-types'

const state = {
  pendingShareCounts: {
    documents: 0,
    folders: 0,
  },
  folders: {
    data: [],
  },
  folder: {
    ancestors: {
      data: [],
    },
    attributes: {
      title: '',
    },
    folders: {
      data: [],
    },
    documents: {
      data: [],
    },
  },
  favoriteDocuments: {
    data: [],
  },
  deleteFolderModal: {
    open: false,
    folder: null,
  },
  editFolderModal: {
    open: false,
    folder: null,
  },
  createFolderModal:  {
    open: false,
  },
  uploadDocumentModal: {
    open: false,
    folderUuid: null,
  },
  deleteDocumentModal: {
    open: false,
    document: null,
  },
  moveDocumentModal: {
    open: false,
    document: null,
  },
  replaceDocumentModal: {
    open: false,
    document: null,
  },
  documentHistoryModal: {
    open: false,
    document: null,
  },
  SendToMembershipGroupsModal: {
    open: false,
    resource: null,
  },
  SendToMembershipsModal: {
    open: false,
    resource: null,
  },
  sendToOrganizationsModal: {
    open: false,
    resource: null,
  },
  editDocumentModal: {
    open: false,
    document: null,
  },
  rejectSharedItemModal: {
    open: false,
    sharedItem: null,
  },
}

const mutations = {
  [types.DOCUMENT_SET_FOLDER](state, Folder) {
    state.folder = Folder
  },
  [types.DOCUMENT_SET_TOP_LEVEL_FOLDERS](state, Folders) {
    state.folders = Folders
  },
  [types.DOCUMENT_SET_PENDING_SHARE_COUNTS](state, Counts) {
    state.pendingShareCounts.documents = Counts.documents
    state.pendingShareCounts.folders = Counts.folders
  },
  [types.DOCUMENT_CLOSE_CREATE_FOLDER_MODAL](state) {
    state.createFolderModal.open = false
  },
  [types.DOCUMENT_OPEN_CREATE_FOLDER_MODAL](state) {
    state.createFolderModal.open = true
  },
  [types.DOCUMENT_CLOSE_UPLOAD_DOCUMENT_MODAL](state) {
    state.uploadDocumentModal.open = false
    state.uploadDocumentModal.folderUuid = null
  },
  [types.DOCUMENT_OPEN_UPLOAD_DOCUMENT_MODAL](state, folderUuid = null) {
    state.uploadDocumentModal.open = true
    state.uploadDocumentModal.folderUuid = folderUuid
  },
  [types.DOCUMENT_OPEN_DELETE_FOLDER_MODAL](state, Folder)
  {
    state.deleteFolderModal.open = true
    state.deleteFolderModal.folder = Folder
  },
  [types.DOCUMENT_CLOSE_DELETE_FOLDER_MODAL](state)
  {
    state.deleteFolderModal.open = false
    state.deleteFolderModal.folder = null
  },
  [types.DOCUMENT_OPEN_DELETE_DOCUMENT_MODAL](state, Document)
  {
    state.deleteDocumentModal.open = true
    state.deleteDocumentModal.document = Document
  },
  [types.DOCUMENT_CLOSE_DELETE_DOCUMENT_MODAL](state)
  {
    state.deleteDocumentModal.open = false
    state.deleteDocumentModal.document = null
  },
  [types.DOCUMENT_OPEN_MOVE_DOCUMENT_MODAL](state, Document)
  {
    state.moveDocumentModal.open = true
    state.moveDocumentModal.document = Document
  },
  [types.DOCUMENT_CLOSE_MOVE_DOCUMENT_MODAL](state)
  {
    state.moveDocumentModal.open = false
    state.moveDocumentModal.document = null
  },
  [types.DOCUMENT_OPEN_REPLACE_DOCUMENT_MODAL](state, Document)
  {
    state.replaceDocumentModal.open = true
    state.replaceDocumentModal.document = Document
  },
  [types.DOCUMENT_CLOSE_REPLACE_DOCUMENT_MODAL](state)
  {
    state.replaceDocumentModal.open = false
    state.replaceDocumentModal.document = null
  },
  [types.DOCUMENT_OPEN_DOCUMENT_HISTORY_MODAL](state, Document)
  {
    state.documentHistoryModal.open = true
    state.documentHistoryModal.document = Document
  },
  [types.DOCUMENT_CLOSE_DOCUMENT_HISTORY_MODAL](state)
  {
    state.documentHistoryModal.open = false
    state.documentHistoryModal.document = null
  },
  [types.DOCUMENT_OPEN_SEND_TO_GROUPS_MODAL](state, Resource)
  {
    state.SendToMembershipGroupsModal.open = true
    state.SendToMembershipGroupsModal.resource = Resource
  },
  [types.DOCUMENT_CLOSE_SEND_TO_GROUPS_MODAL](state)
  {
    state.SendToMembershipGroupsModal.open = false
    state.SendToMembershipGroupsModal.resource = null
  },
  [types.DOCUMENT_OPEN_SEND_TO_MEMBERS_MODAL](state, Resource)
  {
    state.SendToMembershipsModal.open = true
    state.SendToMembershipsModal.resource = Resource
  },
  [types.DOCUMENT_CLOSE_SEND_TO_MEMBERS_MODAL](state)
  {
    state.SendToMembershipsModal.open = false
    state.SendToMembershipsModal.resource = null
  },
  [types.DOCUMENT_OPEN_SEND_TO_ORGANIZATIONS_MODAL](state, Resource)
  {
    state.sendToOrganizationsModal.open = true
    state.sendToOrganizationsModal.resource = Resource
  },
  [types.DOCUMENT_CLOSE_SEND_TO_ORGANIZATIONS_MODAL](state)
  {
    state.sendToOrganizationsModal.open = false
    state.sendToOrganizationsModal.resource = null
  },
  [types.DOCUMENT_OPEN_EDIT_FOLDER_MODAL](state, Folder)
  {
    state.editFolderModal.open = true
    state.editFolderModal.folder = Folder
  },
  [types.DOCUMENT_CLOSE_EDIT_FOLDER_MODAL](state)
  {
    state.editFolderModal.open = false
    state.editFolderModal.folder = null
  },
  [types.DOCUMENT_OPEN_EDIT_DOCUMENT_MODAL](state, Document)
  {
    state.editDocumentModal.open = true
    state.editDocumentModal.document = Document
  },
  [types.DOCUMENT_CLOSE_EDIT_DOCUMENT_MODAL](state)
  {
    state.editDocumentModal.open = false
    state.editDocumentModal.document = null
  },
  [types.DOCUMENT_OPEN_REJECT_SHARED_ITEM_MODAL](state, SharedItem)
  {
    state.rejectSharedItemModal.open = true
    state.rejectSharedItemModal.sharedItem = SharedItem
  },
  [types.DOCUMENT_CLOSE_REJECT_SHARED_ITEM_MODAL](state)
  {
    state.rejectSharedItemModal.open = false
    state.rejectSharedItemModal.sharedItem = null
  },
  [types.DOCUMENT_SET_FAVORITE_DOCUMENTS](state, FavoriteDocuments)
  {
    state.favoriteDocuments = FavoriteDocuments
  },
}

export default {
  state,
  mutations,
}